import { render, staticRenderFns } from "./AsignacionItems.vue?vue&type=template&id=676845ac&scoped=true&"
import script from "./AsignacionItems.vue?vue&type=script&lang=js&"
export * from "./AsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676845ac",
  null
  
)

export default component.exports